export type AzusaRuntime = 'browser' | 'tauri'
export type AzusaPlatform = 'browser' | 'desktop' | 'android' | 'ios'

export function isTauriRuntime(): boolean {
  if (typeof window === 'undefined') return false
  const global = globalThis as typeof globalThis & {
    isTauri?: boolean
    __TAURI_INTERNALS__?: unknown
  }
  return Boolean(global.isTauri || global.__TAURI_INTERNALS__)
}

export function azusaRuntime(): AzusaRuntime {
  return isTauriRuntime() ? 'tauri' : 'browser'
}

export function isAndroidRuntime(): boolean {
  if (!isTauriRuntime() || typeof navigator === 'undefined') return false
  return /Android/i.test(navigator.userAgent)
}

export function azusaPlatform(): AzusaPlatform {
  if (!isTauriRuntime()) return 'browser'
  if (typeof navigator !== 'undefined') {
    if (/Android/i.test(navigator.userAgent)) return 'android'
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) return 'ios'
  }
  return 'desktop'
}
